import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import queryString from 'query-string';

import TagManager from 'react-gtm-module'

import App from './App';

// This is not the right place to do all this.  It's a gross hack to get reporting going quickly.
var qs = queryString.parse(window.location.search);

var facilityId = qs["facilityId"] || qs["f"];
var assetId = qs["assetId"] || qs["a"];
var versionId = qs["versionId"] || qs["v"];

var campaignId = null;
var path = window.location.pathname;

if (path.indexOf("/campaign/") > -1)
    campaignId = path.replace("/campaign/", "");
else
    if (path.indexOf("/c/") > -1)
        campaignId = path.replace("/c/", "");

const tagManagerArgs = {
    gtmId: 'GTM-N55NL43',
    dataLayer: {
        facilityId: facilityId,
        assetId: assetId,
        versionId: versionId,
        campaignId: campaignId
    }
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Switch>
            <Route exact path='/c/:id' render={(params) => <App campaignId={params.match.params.id} />} />
            <Route exact path='/campaign/:id' render={(params) => <App campaignId={params.match.params.id} />} />
            <Route component={App} />
        </Switch>
      </BrowserRouter>,
      rootElement);
